import { render, staticRenderFns } from "./HelloJavaScript.vue?vue&type=template&id=12e909d2&"
import script from "./HelloJavaScript.vue?vue&type=script&lang=js&"
export * from "./HelloJavaScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports